export const CRMTypeDecorator = {
  url() {
    return `signup-hubspot/crm`;
  },
  query() {
    return {};
  }
};